<template>
  <span />
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'Entry',
  created() {
    if (Object.keys(this.userInfo).length) {
      this.$toast('您没有进入该页面的权限');
    }
    this.$router.push('/');
  },
  computed: {
    ...mapGetters(['userInfo'])
  }
}
</script>
